$( document ).ready(function() {



  /* ===== Helpers para ADD/REMOVE ===== */
  function getVariantAndQty($product) {
    var $select = $product.find('.variants-product-stl select');
    var id = $select.val();
    var qty = parseInt($product.find('.qty-input').val()) || 1;
    return { id: id, qty: qty };
  }

  function lockQty($product, lock) {
    var $input = $product.find('.qty-input');
    var $btns = $product.find('.qty-btn');
    $input.prop('disabled', lock);
    $btns.prop('disabled', lock);
    if (lock) $input.attr('readonly','readonly'); else $input.removeAttr('readonly');
    $product.toggleClass('qty-locked', lock);
  }


  

    /* ====== LÍMITES DE CANTIDAD POR VARIANTE (desde DOM) ====== */
  function getVariantMaxFromDOM($select){
    var $opt = $select.find(':selected');
    if (!$opt.length) return 10000;                // fallback generoso
    var policy = String($opt.data('inventory-policy') || '');
    var mgmt   = $opt.data('inventory-mgmt');      // 'shopify' si trackea
    var qty    = Number($opt.data('inventory-qty'));
    if (policy === 'continue') return 10000;       // “Continue selling”
    if (!mgmt) return 10000;                       // no trackea => no limitamos
    if (!isFinite(qty)) qty = 0;
    return Math.max(1, qty);
  }



  function applyQtyLimits($product){
    var $select = $product.find('.variants-product-stl select');
    var max = getVariantMaxFromDOM($select);
    var $input = $product.find('.qty-input');
    var $plus  = $product.find('.qty-btn.qty-plus');
    var $minus = $product.find('.qty-btn.qty-minus');

    $input.attr('max', max);
    var val = parseInt($input.val()) || 1;
    if (val > max) { val = max; $input.val(val); }

    // 👇 Si está lockeado, no re-habilites los botones
    var locked = $product.hasClass('qty-locked') || $input.prop('disabled') === true;
    if (locked) {
      $plus.prop('disabled', true);
      $minus.prop('disabled', true);
    } else {
      $plus.prop('disabled', val >= max);
      $minus.prop('disabled', val <= 1);
    }

    return max;
  }





  /* =========================
   SINCRONIZAR STL DESDE CARRITO
   ========================= */
  function syncShopTheLookWithCart() {
    $.getJSON('/cart.js', function(cart){
      // Mapa: por "ID LOOK" y variant_id -> cantidad (sumamos si hay varias líneas iguales)
      var qtyByLookAndVariant = {}; // key: IDLOOK|variant_id  -> qty
      if (cart && Array.isArray(cart.items)) {
        cart.items.forEach(function(it){
          var idLookProp = it.properties && (it.properties['ID LOOK'] || it.properties['ID Look'] || it.properties['IDLook']);
          if (!idLookProp) return; // solo nos interesan líneas con ID LOOK
          var key = String(idLookProp) + '|' + String(it.variant_id);
          qtyByLookAndVariant[key] = (qtyByLookAndVariant[key] || 0) + Number(it.quantity || 0);
        });
      }

      // Recorremos cada bloque STL
      $('.shop-the-look__container').each(function(){
        var $container = $(this);
        var idLook = $container.data('id-set') || $container.attr('data-id-set') || ''; // tu data-id-set
        var anyActiveInThisContainer = false;

        // Recorremos cada product-item del contenedor
        $container.find('.product-item').each(function(){
          var $product = $(this);
          var $select  = $product.find('.variants-product-stl select');
          if (!$select.length) return; // no hay variantes visibles

          // 1) ¿Alguna opción del select está en el carrito para este ID LOOK?
          var variantIds = [];
          $select.find('option').each(function(){ variantIds.push($(this).val()); });

          // Preferimos el variant actualmente seleccionado si está en el carrito
          var currentId = $select.val();
          var keyCurrent = String(idLook) + '|' + String(currentId);
          var chosenId = null, chosenQty = 0;

          if (qtyByLookAndVariant[keyCurrent] > 0) {
            chosenId  = currentId;
            chosenQty = qtyByLookAndVariant[keyCurrent];
          } else {
            // Si el actual no está, buscamos cualquiera de las opciones que sí esté
            for (var i=0;i<variantIds.length;i++){
              var vid = variantIds[i];
              var key = String(idLook) + '|' + String(vid);
              if (qtyByLookAndVariant[key] > 0) {
                chosenId  = vid;
                chosenQty = qtyByLookAndVariant[key];
                break;
              }
            }
          }

          if (chosenId) {
            // 2-A) Hay línea en carrito: marcamos como agregado
            if ($select.val() !== String(chosenId)) {
              $select.val(String(chosenId)); // cambiamos la variante para reflejar carrito
            }

            // qty igual a carrito y aplicar tope visual
            $product.find('.qty-input').val(chosenQty);
            applyQtyLimits($product);

            // Botón a estado "Remove" + clases activas (como tu UI)
            var $btn = $product.find('button.add-elements-variant')
                              .removeClass('add-elements-variant__add')
                              .addClass('add-elements-variant__remove')
                              .text('Remove');
            $product.removeClass('remove-add-to-cart').addClass('active-add-to-cart');

            // Bloquear qty mientras está en carrito
            if (typeof lockQty === 'function') lockQty($product, true);
            else {
              $product.find('.qty-input').prop('disabled', true).attr('readonly','readonly');
              $product.find('.qty-btn').prop('disabled', true);
              $product.addClass('qty-locked');
            }

            // Actualiza precio unitario visual y seguimos
            updateVariantPrice($select);
            anyActiveInThisContainer = true;

          } else {
            // 2-B) No hay línea en carrito para este producto: dejar en estado "Add"
            var $btn = $product.find('button.add-elements-variant')
                              .removeClass('add-elements-variant__remove')
                              .addClass('add-elements-variant__add')
                              .text('Add');
            $product.removeClass('active-add-to-cart').addClass('remove-add-to-cart');

            // qty por defecto y desbloqueada
            $product.find('.qty-input').val(1);
            applyQtyLimits($product);

            if (typeof lockQty === 'function') lockQty($product, false);
            else {
              $product.find('.qty-input').prop('disabled', false).removeAttr('readonly');
              $product.find('.qty-btn').prop('disabled', false);
              $product.removeClass('qty-locked');
            }

            updateVariantPrice($select);
          }
        }); // end each product-item

        // 3) Recalcula totales del contenedor
        $totalSTL($container);
      }); // end each container

      // Pase final para asegurar que +/- queden bien desde el inicio
     $('.product-item').each(function(){ applyQtyLimits($(this)); });

    });
  }


  /* Guard: evita cambios de qty cuando está bloqueado */
  $(document).on('click', '.qty-btn', function(e){
    if ($(this).closest('.product-item').hasClass('qty-locked')) { e.preventDefault(); return false; }
  });
  $(document).on('change', '.qty-input', function(e){
    if ($(this).closest('.product-item').hasClass('qty-locked')) { e.preventDefault(); return false; }
  });












  // Botón + / -
  $(document).on('click', '.qty-btn', function(e) {
    var $product = $(this).closest('.product-item');
    if ($product.hasClass('qty-locked')) { e.preventDefault(); return false; } // 👈 extra guard

    var max = applyQtyLimits($product);
    var $input = $product.find('.qty-input');
    var currentVal = parseInt($input.val()) || 1;

    if ($(this).hasClass('qty-plus')) {
      if (currentVal < max) $input.val(currentVal + 1);
    } else if ($(this).hasClass('qty-minus') && currentVal > 1) {
      $input.val(currentVal - 1);
    }
    applyQtyLimits($product);
  });

  
  // Cambio manual en el input
  $(document).on('change', '.qty-input', function(e) {
    var $product = $(this).closest('.product-item');
    if ($product.hasClass('qty-locked')) { e.preventDefault(); return false; } // 👈 extra guard

    var max = applyQtyLimits($product);
    var val = parseInt($(this).val()) || 1;
    if (val < 1) val = 1;
    if (val > max) val = max;
    $(this).val(val);
    applyQtyLimits($product);
  });


  $(document).on('click change', '.qty-btn, .qty-input', function() {
    var $select = $(this).closest('.variants-product-stl').find('select');
    updateVariantPrice($select);
  
    var containerShoplook = $(this).parents('.shop-the-look__container');
    $totalSTL($(containerShoplook));
  });





  $(document).on('click', '.scroll-to-products-btn', function(e) {
    e.preventDefault();
    var container = $(this).closest('.shop-the-look__main');
    var firstProduct = container.find('.card-product-item').first();
  
    if (firstProduct.length) {
      var $heightNav = $("header#section-header").height();
      var extraSpace = 20;
      $('html, body').animate({
        scrollTop: firstProduct.offset().top - $heightNav - extraSpace
      }, 600);
    }
  });




  // Función para actualizar precio unitario visualmente
  function updateVariantPrice($select) {
    var $selectedOption = $select.find(':selected');
    var price = Number($selectedOption.data('total')) / 100; // convertir a dólares
    var qty = parseInt($select.closest('.variants-product-stl').find('.qty-input').val()) || 1;
    var totalPrice = price * qty;
  
    $select.closest('.variants-product-stl')
      .find('.variant-price')
      .text(totalPrice.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }));
  }





  

  // Creación de Navigation.
  
    $( '.shopify-section.shop-the-look' ).each(function() {
        var selector = $(this).find('.shop-the-look__container').data('section');
        $('.main-page-shop-the-look .shop-the-look__navigation').append('<button data-link="' + selector +'">'+ selector +'</button>');
    });

  
  // Movimiento del navigation.
  
    $(".shop-the-look__navigation button").click(function() {
      var section = $(this).data('link');
      var selector = '.shop-the-look__container[data-section="' + section + '"]';
      var $heightNav = $("header#section-header").height();
      $("html, body").animate({ scrollTop: $(selector).offset().top - $heightNav }, "slow");
      return false;
    });


  // Precios del Shop the Look cuando carga el site.
  
    $( ".shop-the-look__container" ).each(function( index ) {
        $totalSTL($(this));
    });
    // Establece límites iniciales por producto
    $('.product-item').each(function(){ applyQtyLimits($(this)); });

    $(window).on('load', function(){
     $('.product-item').each(function(){ applyQtyLimits($(this)); });
    });


  // Precios del Shop the Look cuando cambia una variante.
  
    $(".variants-product-stl select").on('change', function() {
        var $value = '.class-' + $( this ).val();
        var $price = $($value).data('price');
        var $html = $(this).parents('.product-item').find('.card-information .price .price__container .price-item--regular');
        $($html).text($price);

        updateVariantPrice($(this));
      
        var containerShoplook = $(this).parents('.shop-the-look__container');
        $totalSTL($(containerShoplook));

        applyQtyLimits($(this).closest('.product-item'));
    });





    // REMOVE individual: elimina SOLO la línea que tenga el mismo variant + IDLook
    $(document).on('click','button.add-elements-variant.add-elements-variant__remove', function(e){

      var $btn = $(this).prop('disabled', true);
      var $product = $btn.closest('.product-item');

      // 1) Datos base
      var $select = $product.find('.variants-product-stl select');
      var variantId = $select.val();

      // 2) Leemos el IDLook del contenedor
      var containerShoplook = $btn.parents('.shop-the-look__container');
      var idLook = containerShoplook.data('id-set') || containerShoplook.attr('data-id-set') || ''; // tu data-* tiene el valor; la property se llama "IDLook"

      // Helper local para actualizar tu UI (igual a tu código original + desbloqueo qty)
      function updateUIAfterRemove() {
        // --- TU UI original ---
        $product.find('.qty-input').val(1);

        $btn.removeClass('add-elements-variant__remove')
            .addClass('add-elements-variant__add')
            .text('Add');

        $product.removeClass('active-add-to-cart')
                .addClass('remove-add-to-cart');

        // Desbloquear qty
        if (typeof lockQty === 'function') {
          lockQty($product, false);
        } else {
          // fallback por si aún no añadiste lockQty
          $product.find('.qty-input').prop('disabled', false).removeAttr('readonly');
          $product.find('.qty-btn').prop('disabled', false);
          $product.removeClass('qty-locked');
        }

        // Recalcular totales y precio visual
        $totalSTL(containerShoplook);
        updateVariantPrice($select);
      }

      // 3) Traemos el carrito para encontrar la línea exacta (variant + IDLook)
      $.getJSON('/cart.js', function(cart){
        if (!cart || !Array.isArray(cart.items)) {
          // fallback si algo falla: borra por variant id (puede eliminar otras líneas con el mismo variant)
          var payload = {}; payload['updates['+variantId+']'] = 0;
          $.ajax({
            type: 'POST', url: '/cart/update.js', dataType: 'json', data: payload,
            complete: function(){ updateUIAfterRemove(); $btn.prop('disabled', false); }
          });
          return;
        }

        // Buscar la línea que coincida con variantId y properties.IDLook == idLook
        var targetItem = null;
        for (var i=0; i<cart.items.length; i++) {
          var it = cart.items[i];
          var sameVariant = (String(it.variant_id) === String(variantId));
          var sameLook = it.properties && (it.properties['ID LOOK'] === idLook);
          if (sameVariant && sameLook) { targetItem = it; break; }
        }

        if (targetItem && targetItem.key) {
          // 4-A) Eliminar por "line item key" (preciso para esa combinación)
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: targetItem.key, quantity: 0 }, // elimina solo esa línea
            success: function(){
              updateUIAfterRemove();
              // Re-sincroniza por si hay más items del mismo look
              syncShopTheLookWithCart();
            },
            error: function(xhr){ console.log('Error al eliminar (change):', xhr && xhr.responseText); },
            complete: function(){ $btn.prop('disabled', false); }
          });
        } else {
          // 4-B) Fallback: eliminar por variant id (puede afectar otras líneas del mismo variant)
          var payload2 = {}; payload2['updates['+variantId+']'] = 0;
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: payload2,

            success: function(){
              updateUIAfterRemove();
              syncShopTheLookWithCart();
            },


            error: function(xhr){ console.log('Error al eliminar (update):', xhr && xhr.responseText); },
            complete: function(){ $btn.prop('disabled', false); }
          });
        }
      });
    });













  // Click en botón de ADD en los items. 
  
    $(document).on('click','button.add-elements-variant.add-elements-variant__add',function(){

        var $btn = $(this).prop('disabled', true);
        var $product = $btn.closest('.product-item');
        var data = getVariantAndQty($product);

        var containerShoplook = $btn.parents('.shop-the-look__container');
        var idSet = containerShoplook.data('id-set') || containerShoplook.attr('data-id-set') || '';

        var payload = {
          items: [{
            id: data.id,
            quantity: data.qty,
            properties: {
              "ID LOOK": idSet
            }
          }]
        };
        

        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify(payload),
        success: function() {

          $btn.removeClass('add-elements-variant__add')
              .addClass('add-elements-variant__remove')
              .text('Remove');
          $product.removeClass('remove-add-to-cart').addClass('active-add-to-cart');

          // Bloquea qty cuando está en el carrito
          lockQty($product, true);

          
          $totalSTL(containerShoplook);
          var $select = $product.find('.variants-product-stl select');
          updateVariantPrice($select);

          syncShopTheLookWithCart();


           // 🚀 INICIO DE LA ANIMACIÓN GSAP (bolita vuela al carrito)
          try {
            // Intenta ubicar el ícono del carrito con varios selectores comunes (ajusta el primero si tienes uno específico)
            var cartIcon = document.querySelector('.Header__Icon--cart-drawer-rebuy');
            
            if (window.gsap && cartIcon) {
              // Crea el "flyer" (bolita)
              var flyer = document.createElement('div');
              flyer.classList.add('cart-flyer');

              // Evita layout-shifts: cuélgalo directo del body
              document.body.appendChild(flyer);

              // Posiciones corregidas por scroll
              var btnRect  = $btn[0].getBoundingClientRect();
              var cartRect = cartIcon.getBoundingClientRect();

              var startX = btnRect.left + btnRect.width  / 2;
              var startY = btnRect.top  + btnRect.height / 2;
              var endX   = cartRect.left + cartRect.width  / 2;
              var endY   = cartRect.top  + cartRect.height / 2;

              // Posición inicial fija en el viewport
              gsap.set(flyer, { position: 'fixed', left: startX, top: startY, opacity: 1, scale: 1 });
              // Vuelo directo (sin plugin)
              gsap.to(flyer, {
                duration: 1.5,
                x: endX - startX,
                y: endY - startY,
                scale: 1,
                opacity: 0.3,
                ease: "power2.inOut",
                onComplete: function(){ flyer.remove(); }
              });
            }
          } catch(e) {
            console.warn('Animación GSAP no ejecutada:', e);
          }
          // 🚀 FIN DE LA ANIMACIÓN GSAP

        },
        error: function(xhr){
          console.log('Error al agregar:', xhr && xhr.responseText);
        },
        complete: function(){
          $btn.prop('disabled', false);
        }
      });


    });


  // Función Total de Shop the Look.

    function $totalSTL(x){
      var sumTotal = 0;
      var allProducts = 0;

      var totalSelectSection = $(x).find('.product-item .variants-product-stl select');
      $(totalSelectSection).each(function(index) {
        var $val = '.class-' + $(this).val();
        var $priceTotal = $($val).data('total');
        var qty = parseInt($(this).closest('.variants-product-stl').find('.qty-input').val()) || 1;
        allProducts += Number($priceTotal) * qty;
      });
    
      var selectSection = $(x).find('.product-item.active-add-to-cart .variants-product-stl select');
      $(selectSection).each(function(index) {
        var $val = '.class-' + $(this).val();
        var $priceTotal = $($val).data('total');
        var qty = parseInt($(this).closest('.variants-product-stl').find('.qty-input').val()) || 1;
        sumTotal += Number($priceTotal) * qty;
      });


      var total = (sumTotal/100);

      if(total <= 0){
        $(x).find('.add-to-cart-stl__price-total').hide();
        $(x).find('.scroll-to-products-btn').show();
        
        $(x).find('.add-to-cart-stl__prices p.add-to-cart-stl__price-offert').addClass('remove-price-offert');
        $(x).find('.add-to-cart-stl__prices p.add-to-cart-stl__price-discount').addClass('remove-discount-offert');
        $(x).find('.add-to-cart-stl .add-all').addClass('remove-button-off');
      } else {        
        $(x).find('.add-to-cart-stl__price-total').show();
        $(x).find('.scroll-to-products-btn').hide();

        $(x).find('.add-to-cart-stl__prices p.add-to-cart-stl__price-offert').removeClass('remove-price-offert');
        $(x).find('.add-to-cart-stl__prices p.add-to-cart-stl__price-discount').removeClass('remove-discount-offert');
        $(x).find('.add-to-cart-stl .add-all').removeClass('remove-button-off');
      };

      if(total <= 0){
        var offer = total * 0;
        var discountOffer = "0% OFF";
      } else if(total >= 1 && total <= 449.99) {
        var offer = total * (1 - 0.10); 
        var discountOffer = "10% OFF";
      } else if(total >= 450.00 && total <= 599.99) {
        var offer = total * (1 - 0.15);
        var discountOffer = "15% OFF";
      } else if(total >= 600.00){
        var offer = total * (1 - 0.20);
        var discountOffer = "20% OFF";
      };
      
      
      var selectorTotal = $(x).find('.add-to-cart-stl__prices p.add-to-cart-stl__price-total');
      var selectorOffer = $(x).find('.add-to-cart-stl__prices p.add-to-cart-stl__price-offert');
      var selectorDiscount = $(x).find('.add-to-cart-stl__prices p.add-to-cart-stl__price-discount');
      $(selectorTotal).text(total.toLocaleString("en-US",{style:"currency",currency:"USD"}));
      $(selectorOffer).text(offer.toLocaleString("en-US",{style:"currency",currency:"USD"}));
      $(selectorDiscount).text(discountOffer);
    };

  
  // Add to Cart Button

  /*
    $(document).on('click', '.add-to-cart-stl button.add-all', function() {
  
          var productosData = [];
  
          var containerShoplook = $(this).parents('.shop-the-look__container');
          var selectItems = $(containerShoplook).find('.product-item.active-add-to-cart .variants-product-stl select');
          $(selectItems).each(function() {
              var $val = $( this ).val();
              var qty = parseInt($(this).closest('.variants-product-stl').find('.qty-input').val()) || 1;
              var objeto = {
                  id: $val,
                  quantity: qty
              };
              productosData.push(objeto);
          });
  
          console.log(productosData);
  
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                items: productosData
              },
              dataType: 'json',
              success: function() {
                console.log('Productos agregados al carrito con éxito');
              },
              error: function(XMLHttpRequest, textStatus, errorThrown) {
                console.log('Error al agregar los productos al carrito');
              }
            });
      
      });

      */


    $(document).on('click', '.add-to-cart-stl button.add-all', function(e) {
      e.preventDefault();
      const SmartCartOpenRebuy = window.Rebuy.SmartCart;
      SmartCartOpenRebuy.show(event);
    });


    syncShopTheLookWithCart();

    /* =========================
      INTEGRACIÓN CON REBUY CART
      ========================= */
    // Debounce simple para no saturar llamadas si Rebuy emite múltiples eventos seguidos
    function debounce(fn, wait) {
      var t; 
      return function() { 
        clearTimeout(t); 
        t = setTimeout(fn, wait); 
      };
    }

    // Evita registrar dos veces si se evalúa el script más de una vez
    if (!window.__STL_REBUY_SYNC_BOUND__) {
      window.__STL_REBUY_SYNC_BOUND__ = true;
      var syncFromRebuy = debounce(function(){
        // Traemos el estado real del carrito y reflejamos en STL
        syncShopTheLookWithCart();
      }, 120);

      // Se dispara cuando Rebuy cambia el carrito (add/remove/update)
      document.addEventListener('rebuy:cart.change', function(event){
        console.log('CUSTOM - rebuy:cart.change', event && event.detail);
        syncFromRebuy();
      });

      // Opcional: al inicializar/mostrar carrito de Rebuy también sincronizamos
      document.addEventListener('rebuy:cart.ready', function(event){
        console.log('CUSTOM - rebuy:cart.ready', event && event.detail);
        syncFromRebuy();
      });
    }

});


/* Altura de Titulos. */

  var title = ".product-item .card__information h3.card__heading.h5";
  $(window).on('load', function () {
      var $height = $(title).map(function (){
        return $(this).height();
      }).get();
      var minHeight = Math.max.apply(null, $height);
      $(title).css({
        'min-height': minHeight
      });
  });

  $(window).resize(function() {
      $(title).css({
        'min-height':'0'
      });
      var $height  = $(title).map(function (){
        return $(this).height();
      }).get();
      var minHeight = Math.max.apply(null, $height);
      $(title).css({
        'min-height':minHeight
      });
  });


/* Altura de Sección Select en Variantes. */

  var variants = ".product-item .variants-product-stl";
  $(window).on('load', function () {
      var $height = $(variants).map(function (){
        return $(this).height();
      }).get();
      var minHeight = Math.max.apply(null, $height);
      $(variants).css({
        'min-height': minHeight
      });
  });

  $( window ).resize(function() {
      $(variants).css({
        'min-height':'0'
      });
      var $height  = $(variants).map(function (){
        return $(this).height();
      }).get();
      var minHeight = Math.max.apply(null, $height);
      $(variants).css({
        'min-height':minHeight
      });
  });


/* Altura de Imagenes. */

  var image = ".stl-general__image.stl-general__image--desktop img";
  var product = ".stl-collection__container .product-item";
  $(window).on('load', function () {
      var $height = $(product).map(function (){
        return $(this).height();
      }).get();
      var minHeight = Math.max.apply(null, $height);
      $(image).css({
        'height': minHeight
      });
  });
  
  $( window ).resize(function() {
      $(image).css({
        'height':'0'
      });
      var $height = $(product).map(function (){
        return $(this).height();
      }).get();
      var minHeight = Math.max.apply(null, $height);
      $(image).css({
        'height':minHeight
      });
  });
